"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LICENSE_TEMPLATES = exports.APosLicenseRecordCreateInputSchema = exports.APosLicenseRecordSchema = exports.APosLocationLicenseUpdateInputSchema = exports.APosLocationLicenseCreateInputSchema = exports.APosLocationLicenseSchema = exports.APosLicenseDocumentTypeSchema = exports.APosLocationLicenseStatusSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosLocationLicenseStatusSchema = zod_1.z.enum(['active', 'expired', 'pending-renewal']);
exports.APosLicenseDocumentTypeSchema = zod_1.z.enum(['pdf', 'image', 'link']);
exports.APosLocationLicenseSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    licenseId: id_schema_1.EntityIdSchema,
    locationId: id_schema_1.EntityIdSchema,
    name: zod_1.z.string().min(1).max(300),
    templateType: zod_1.z.string().max(100).optional(),
    issuingAuthority: zod_1.z.string().max(200).optional(),
    licenseNumber: zod_1.z.string().max(100).optional(),
    notes: zod_1.z.string().max(1000).optional(),
    status: exports.APosLocationLicenseStatusSchema.default('active'),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosLocationLicenseCreateInputSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(300),
    templateType: zod_1.z.string().max(100).optional(),
    issuingAuthority: zod_1.z.string().max(200).optional(),
    licenseNumber: zod_1.z.string().max(100).optional(),
    notes: zod_1.z.string().max(1000).optional(),
});
exports.APosLocationLicenseUpdateInputSchema = exports.APosLocationLicenseCreateInputSchema.partial().extend({
    status: exports.APosLocationLicenseStatusSchema.optional(),
});
exports.APosLicenseRecordSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    recordKey: zod_1.z.string(),
    licenseId: id_schema_1.EntityIdSchema,
    year: zod_1.z.number().int().min(2000).max(2100),
    issueDate: zod_1.z.number().optional(),
    expiryDate: zod_1.z.number().optional(),
    cost: zod_1.z.number().nonnegative().optional(),
    documentUrl: zod_1.z.string().optional(),
    documentType: exports.APosLicenseDocumentTypeSchema.optional(),
    externalLink: zod_1.z.string().url().optional(),
    notes: zod_1.z.string().max(1000).optional(),
    uploadedAt: zod_1.z.number(),
});
exports.APosLicenseRecordCreateInputSchema = zod_1.z.object({
    year: zod_1.z.number().int().min(2000).max(2100),
    issueDate: zod_1.z.number().optional(),
    expiryDate: zod_1.z.number().optional(),
    cost: zod_1.z.number().nonnegative().optional(),
    documentUrl: zod_1.z.string().optional(),
    documentType: exports.APosLicenseDocumentTypeSchema.optional(),
    externalLink: zod_1.z.string().url().optional(),
    notes: zod_1.z.string().max(1000).optional(),
});
exports.LICENSE_TEMPLATES = [
    { id: 'business-license', name: 'Business License' },
    { id: 'food-service-permit', name: 'Food Service Permit' },
    { id: 'liquor-license', name: 'Liquor License' },
    { id: 'health-department-permit', name: 'Health Department Permit' },
    { id: 'fire-safety-certificate', name: 'Fire Safety Certificate' },
    { id: 'sales-tax-permit', name: 'Sales Tax Permit' },
    { id: 'signage-permit', name: 'Signage Permit' },
    { id: 'occupancy-permit', name: 'Occupancy Permit' },
];
//# sourceMappingURL=location-license.schema.js.map